class HistoryElements {
  constructor(numberOfHistoryElements = 3) {
    this._numberOfHistoryElements = numberOfHistoryElements;
    this._historyElements = [];
    this._lastIndex = 0;
  }

  push = (element) => {
    if (this._numberOfHistoryElements > this._historyElements.length) {
      this._historyElements.push(element);
      this._lastIndex++;

      return this;
    }

    this._historyElements.shift();
    this._historyElements.push(element);

    return this;
  }

  size = () => {
    return this._historyElements.length;
  }

  at = (index) => {
    if (index > this._historyElements.length - 1) {
      return undefined;
    }

    const idx = this._historyElements.length - 1 - index;
    return this._historyElements[idx];
  }

  getAll = () => {
    return [...this._historyElements];
  }

  getYongest = () => {
    return this._historyElements[this._historyElements.length - 1];
  }

  getOldest = () => {
    return this._historyElements[0];
  }
}

export default HistoryElements;
